import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const SEND_MESSAGE_STREAM_INIT = 'SEND_MESSAGE_STREAM_INIT';
export const SEND_MESSAGE_STREAM_THINKING = 'SEND_MESSAGE_STREAM_THINKING';
export const SEND_MESSAGE_STREAM_CHUNK = 'SEND_MESSAGE_STREAM_CHUNK';
export const SEND_MESSAGE_STREAM_COMPLETE = 'SEND_MESSAGE_STREAM_COMPLETE';
export const SEND_MESSAGE_STREAM_ERROR = 'SEND_MESSAGE_STREAM_ERROR';
export const SEND_MESSAGE_STREAM_RESET = 'SEND_MESSAGE_STREAM_RESET';
export const SEND_MESSAGE_STREAM_SET_CONVERSATION_ID =
	'SEND_MESSAGE_STREAM_SET_CONVERSATION_ID';

export const sendMessageStreamInit = (params) => {
	return {
		type: SEND_MESSAGE_STREAM_INIT,
		params,
	};
};

export const sendMessageStreamThinking = (text) => {
	return {
		type: SEND_MESSAGE_STREAM_THINKING,
		thinkingText: text,
	};
};

export const sendMessageStreamChunk = (text, fullText) => {
	return {
		type: SEND_MESSAGE_STREAM_CHUNK,
		text,
		fullText,
	};
};

export const sendMessageStreamComplete = (response) => {
	return {
		type: SEND_MESSAGE_STREAM_COMPLETE,
		response,
	};
};

export const sendMessageStreamError = (error) => {
	return {
		type: SEND_MESSAGE_STREAM_ERROR,
		error,
	};
};

export const sendMessageStreamReset = () => {
	return {
		type: SEND_MESSAGE_STREAM_RESET,
	};
};

export const sendMessageStreamSetConversationId = (conversationId) => {
	return {
		type: SEND_MESSAGE_STREAM_SET_CONVERSATION_ID,
		conversationId,
	};
};

export const sendMessageStreamApi = (data) => {
	return (dispatch) => {
		dispatch(sendMessageStreamInit(data));

		// Use a POST request that properly handles SSE
		fetch(`${config.api.base_url}/voice-assistance/message/stream`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + getUserToken(),
			},
			body: JSON.stringify(data),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}

				// Create a reader for the response body stream
				const reader = response.body.getReader();
				const decoder = new TextDecoder();
				let buffer = '';

				// Process the stream
				function processStream() {
					return reader.read().then(({ done, value }) => {
						if (done) {
							return;
						}

						// Decode the chunk and add it to our buffer
						buffer += decoder.decode(value, { stream: true });

						// Process complete events in the buffer
						const lines = buffer.split('\n\n');
						buffer = lines.pop() || ''; // Keep the last incomplete chunk in the buffer

						for (const line of lines) {
							if (line.trim() === '') continue;

							// Parse the SSE data
							const dataMatch = line.match(/^data: (.+)$/m);
							if (dataMatch && dataMatch[1]) {
								try {
									const eventData = JSON.parse(dataMatch[1]);

									// Handle different event types
									switch (eventData.event) {
										case 'conversation_id':
											dispatch(
												sendMessageStreamSetConversationId(
													eventData.conversation_id,
												),
											);
											break;

										case 'thinking':
											dispatch(
												sendMessageStreamThinking(
													eventData.text,
												),
											);
											break;

										case 'chunk':
											dispatch(
												sendMessageStreamChunk(
													eventData.text,
													eventData.fullText,
												),
											);
											break;

										case 'complete':
											dispatch(
												sendMessageStreamComplete(
													eventData.response,
												),
											);
											return; // End the stream processing

										case 'error':
											dispatch(
												sendMessageStreamError(
													eventData.error,
												),
											);
											return; // End the stream processing

										case 'end':
											return; // End the stream processing
									}
								} catch (e) {
									console.error('Error parsing SSE data:', e);
								}
							}
						}

						// Continue processing the stream
						return processStream();
					});
				}

				// Start processing the stream
				return processStream();
			})
			.catch((error) => {
				console.error('Streaming error:', error);
				dispatch(sendMessageStreamError(error.message));
			});
	};
};
